import { render, staticRenderFns } from "./notification-bell.vue?vue&type=template&id=54325350&scoped=true&"
import script from "./notification-bell.vue?vue&type=script&lang=js&"
export * from "./notification-bell.vue?vue&type=script&lang=js&"
import style0 from "./notification-bell.vue?vue&type=style&index=0&id=54325350&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54325350",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAlert,VBadge,VBtn,VIcon,VList,VListItem,VListItemContent,VMenu})
